import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import {LoginPage, AccountDashboard, AccountSelection, SignupPage,
  AppLoader, DashboardLayout, PairsPage, FundsPage, SettingsPage, OrdersPage, ReportsPage,
  SummaryReportPage, EOYSummaryReportPage, MonthlyDrillDownPage, YearlyTaxReportPage, TrendsPage, EventsPage, AnalysisPage} from './pages';
import {UpdateDashboard, UploadUpdate, UpdateHistory} from './pages/Admin';

import './index.css';
import './ux/globals.css';
import { RootProvider } from './context/RootProvider';
import {PrivateRoute, AdminRoute} from './components/Routes';

const App: React.FC = () => {
  return (
    <RootProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          
          <Route element={<PrivateRoute />}>
            <Route path="/app" element={<AppLoader />} />
            <Route path="/dashboard" element={<AccountDashboard />} />
            <Route path="/profile" element={<DashboardLayout />}>
              <Route index element={<SettingsPage />} />
            </Route>
            <Route path="/account/:accountId" element={<DashboardLayout />}>
              <Route index element={<AccountDashboard />} />
              <Route path="pairs" element={<PairsPage />} />
              <Route path="orders" element={<OrdersPage />} />
              <Route path="funds" element={<FundsPage />} />
              <Route path="trends" element={<TrendsPage />} />
              <Route path="analysis" element={<AnalysisPage />} />
              <Route path="events" element={<EventsPage />} />
              <Route path="reports">
                <Route index element={<ReportsPage />} />
                <Route path="summary" element={<SummaryReportPage />} />
                <Route path="eoy-summary" element={<EOYSummaryReportPage />} />
                <Route path="monthly-drilldown" element={<MonthlyDrillDownPage />} />
                <Route path="tax-report" element={<YearlyTaxReportPage />} />
              </Route>
              <Route path="settings" element={<Navigate to="/profile" replace />} />
            </Route>
            <Route path="/accounts" element={<AccountSelection />} />
          </Route>

           {/* Admin Update Routes */}
           <Route element={<AdminRoute />}>
            <Route path="/updates" element={<DashboardLayout />}>
              <Route index element={<UpdateDashboard />} />
              <Route path="upload" element={<UploadUpdate />} />
              <Route path="history" element={<UpdateHistory />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </RootProvider>
  );
};

export default App;
